import Swal from "sweetalert2";

export const showReferralAlert = (options) => Swal.fire({
  confirmButtonColor: "#078568",
  confirmButtonText: "OK",
  ...options,
});

export const showManualCopyAlert = (title, value) => showReferralAlert({
  icon: "info",
  title,
  text: "Clipboard access is unavailable. Select and copy the text below.",
  input: "textarea",
  inputValue: value,
  inputAttributes: { readOnly: true, "aria-label": title },
  didOpen: () => Swal.getInput()?.select(),
});
